import { Box, IconButton, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { VisibilityOffOutlined, VisibilityOutlined } from '@material-ui/icons';
import { FC, useState } from 'react';

interface MaskedValueProps {
  value: string;
  dataTestId?: string;
  fullyMasked?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    maskedDots: {
      lineHeight: 1,
      verticalAlign: 'baseline',
      letterSpacing: '1px',
    },
    visibilityToggle: {
      padding: theme.spacing(0, 0, 0, 1.25),
      '& .MuiSvgIcon-root': {
        width: 20,
        height: 20,
      },
    },
  }),
);

const maskValue = (val: string, maskAllDigits = false): string => {
  const digits = val.replace(/\D/g, '');
  if (!maskAllDigits && digits.length >= 7) {
    return '\u2022'.repeat(digits.length - 4) + digits.slice(-4);
  }
  return '\u2022'.repeat(digits.length || val.length);
};

const MaskedValue: FC<MaskedValueProps> = ({ value, dataTestId, fullyMasked = false }) => {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(false);
  const maskedStr = maskValue(value, fullyMasked);
  const dotMatch = maskedStr.match(/^(\u2022+)(.*)/);

  return (
    <Box className={classes.root} data-testid="masked-value">
      <Typography component="span">
        {!fullyMasked && isVisible ? (
          value
        ) : dotMatch ? (
          <>
            <span className={classes.maskedDots}>{dotMatch[1]}</span>
            {dotMatch[2]}
          </>
        ) : (
          maskedStr
        )}
      </Typography>
      {!fullyMasked && (
        <IconButton
          className={classes.visibilityToggle}
          size="small"
          onClick={() => setIsVisible(!isVisible)}
          aria-label={isVisible ? 'Hide value' : 'Show value'}
          data-testid={dataTestId}
        >
          {isVisible ? <VisibilityOutlined fontSize="small" /> : <VisibilityOffOutlined fontSize="small" />}
        </IconButton>
      )}
    </Box>
  );
};

export default MaskedValue;
